import type { useProposalStudio } from './useProposalStudio'
import { ProposalStudioSlideSelector } from './ProposalStudioSlideSelector'
import { ProposalStudioComboEditors } from './ProposalStudioComboEditors'
import { ProposalStudioPlanForm } from './ProposalStudioPlanForm'

type Studio = ReturnType<typeof useProposalStudio>

export function ProposalStudioEditorColumn({ s }: { s: Studio }) {
  return (
    <div className="w-[42%] border-r border-white/[0.06] overflow-y-auto premium-scroll p-5 space-y-4">
      <ProposalStudioSlideSelector s={s} />
      {s.comboVariations.length > 0 ? (
        <ProposalStudioComboEditors s={s} />
      ) : s.activePlan ? (
        <ProposalStudioPlanForm s={s} />
      ) : (
        <div className="h-40 flex items-center justify-center text-text-muted">
          Nenhum item na proposta. Adicione na aba &quot;Itens&quot;.
        </div>
      )}
    </div>
  )
}
